<template>
  <div class="slider-inner slider-e">
    <Logo />

    <div class="e1 animated fadeInUp">
      <div class="inner" @touchstart.stop>
        <img src="~images/e/e_1_1.png" />
        <div class="fix">
          <a
            href="https://xym.51job.com/wechat/vuectmjobs/#/index?id=4a375bb5-cb6b-4a6a-bff2-a02e8c9bce9c&color=31BE88"
            target="_blank"
          >
            <img src="~images/e/e_1_2.png" />
          </a>
        </div>
      </div>
    </div>
    <img class="e2 animated zoomIn" src="~images/e/e_2.png" />
    <div class="e3 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_4.png" />
    </div>
    <div class="e4 animated fadeInLeft">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_3.png" />
    </div>
    <img class="e5 animated fadeInLeft" src="~images/b/b_7.png" />
    <img class="e6 animated fadeInRight" src="~images/b/b_8.png" />
    <img class="e7" src="~images/b/b_9.png" />
    <div class="e8 animated fadeInRight">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_5.png" />
    </div>
    <div class="e9 animated fadeInUp">
      <img class="animated yoyoY infinite alternate" src="~images/b/b_6.png" />
    </div>

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderE",
};
</script>

<style lang="less" scoped>
.slider-e {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  .e1 {
    position: absolute;
    top: 20%;
    right: 5%;
    bottom: 20%;
    left: 5%;
    padding: 0.47rem 0.18rem 0.2rem;
    background: url("~images/d/d_1.png") center top / 100% 100%;
    .inner {
      position: relative;
      height: 100%;
      overflow: auto;
      .fix {
        position: sticky;
        left: 0;
        bottom: 0;
        right: 0;
        padding: 0.2rem 0;
        background: white;
        z-index: 99;
        a {
          width: 3.04rem;
          margin: 0 auto;
          display: block;
        }
      }
    }
  }
  .e2 {
    position: absolute;
    top: 13.5%;
    left: 50%;
    width: 4.42rem;
    margin-left: -4.42/2rem;
  }
  .e3 {
    position: absolute;
    top: 17%;
    right: 0.55rem;
    width: 1.21rem;
  }
  .e4 {
    position: absolute;
    top: 14.5%;
    left: 0.7rem;
    width: 0.53rem;
  }
  .e5 {
    position: absolute;
    left: 0.5rem;
    bottom: 0;
    width: 3.2rem;
  }
  .e6 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 3.6rem;
  }
  .e7 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .e8 {
    position: absolute;
    bottom: 18%;
    left: 0;
    width: 0.79rem;
    z-index: 5;
  }
  .e9 {
    position: absolute;
    top: 55%;
    right: 0.05rem;
    width: 0.3rem;
    animation-delay: 0.4s;
  }
}
</style>